import { Link } from '@dropbox/dig-components/typography';
import React from 'react';
import classnames from 'classnames';
import HyperlinkInterstitialModal from 'signer-app/signature-request/hyperlink-interstitial-modal';
import { Field } from 'signer-app/types/editor-types';
import { DEFAULT_FONT_FAMILY } from 'signer-app/signature-request/constants';
import textStyles from 'signer-app/signature-request/display-field/text.module.css';

export function Hyperlink(props: {
  field: Extract<Field, { type: 'hyperlink' }>;
}) {
  const { field } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  const fontFamily = field.fontFamily || DEFAULT_FONT_FAMILY;

  return (
    <>
      <Link
        href={field.url}
        onClick={(evt) => {
          setIsOpen(true);
          evt.preventDefault();
        }}
        className={classnames(textStyles[`font--${fontFamily}`])}
      >
        {field.value}
      </Link>
      <HyperlinkInterstitialModal
        link={field.url}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
      />
    </>
  );
}
